module.exports = {"title":"Как я провел этим годом","description":"Годовой отчёт 2017. Всё самое главное — от Трампа до Вайнштейна и биткоина","image":"https://2017.rambler-co.ru/img/og/share_01.jpg","url":"https://2017.rambler-co.ru/","share":"https://2017.rambler-co.ru/share.php","fbappid":396959934055666,"GTM":"GTM-576SVDP","top100":0,"clientTop100":0,"yaMetrika":0}


//////////////////
// WEBPACK FOOTER
// ./js/meta.json
// module id = 15
// module chunks = 12